<template>
  <div class="password-field">
    <el-input :type="showInput ? 'text' : 'password'" v-model="inputValue" v-bind="$attrs">
      <i slot="suffix" class="iconfont" :class="showInput ? 'icon-open-eye' : 'icon-close-eye'" @click="toggleShowInput"></i>
    </el-input>
  </div>
</template>

<script>
import Emitter from 'element-ui/lib/mixins/emitter'
export default {
  mixins: [Emitter],
  name: 'PasswordField',
  props: {
    value: {
      required: true
    }
  },
  data () {
    return {
      showInput: false
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
        this.dispatch('ElFormItem', 'el.form.blur', val)
      }
    }
  },
  methods: {
    toggleShowInput () {
      this.showInput = !this.showInput
    }
  }
}
</script>

<style lang="scss">
  .password-field {
    .el-input {
      & > .el-input__suffix {
        right: 8px;
        & > .el-input__suffix-inner {
          display: inline-block;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
          cursor: pointer;
          &:hover {
            i {
              color: #909399;
            }
          }
        }
      }
    }
  }
</style>
